export default "__VITE_ASSET__cc317966__"